module.exports = __webpack_public_path__ + "img/scorecard-8.dadf5d1d.jpg";